// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: thoughtspot.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "com.meritic.newton.ts";

export enum DataWarehouseType {
  INVALID_DATA_WAREHOUSE_TYPE = 0,
  SNOWFLAKE = 1,
  GOOGLE_BIGQUERY = 2,
  POSTGRES = 3,
  SQLSERVER = 4,
  UNRECOGNIZED = -1,
}

export function dataWarehouseTypeFromJSON(object: any): DataWarehouseType {
  switch (object) {
    case 0:
    case "INVALID_DATA_WAREHOUSE_TYPE":
      return DataWarehouseType.INVALID_DATA_WAREHOUSE_TYPE;
    case 1:
    case "SNOWFLAKE":
      return DataWarehouseType.SNOWFLAKE;
    case 2:
    case "GOOGLE_BIGQUERY":
      return DataWarehouseType.GOOGLE_BIGQUERY;
    case 3:
    case "POSTGRES":
      return DataWarehouseType.POSTGRES;
    case 4:
    case "SQLSERVER":
      return DataWarehouseType.SQLSERVER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataWarehouseType.UNRECOGNIZED;
  }
}

export function dataWarehouseTypeToJSON(object: DataWarehouseType): string {
  switch (object) {
    case DataWarehouseType.INVALID_DATA_WAREHOUSE_TYPE:
      return "INVALID_DATA_WAREHOUSE_TYPE";
    case DataWarehouseType.SNOWFLAKE:
      return "SNOWFLAKE";
    case DataWarehouseType.GOOGLE_BIGQUERY:
      return "GOOGLE_BIGQUERY";
    case DataWarehouseType.POSTGRES:
      return "POSTGRES";
    case DataWarehouseType.SQLSERVER:
      return "SQLSERVER";
    case DataWarehouseType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DataWarehouseObjectType {
  INVALID_DATA_WAREHOUSE_OBJECT_TYPE = 0,
  DATABASE = 1,
  SCHEMA = 2,
  TABLE = 3,
  COLUMN = 4,
  UNRECOGNIZED = -1,
}

export function dataWarehouseObjectTypeFromJSON(object: any): DataWarehouseObjectType {
  switch (object) {
    case 0:
    case "INVALID_DATA_WAREHOUSE_OBJECT_TYPE":
      return DataWarehouseObjectType.INVALID_DATA_WAREHOUSE_OBJECT_TYPE;
    case 1:
    case "DATABASE":
      return DataWarehouseObjectType.DATABASE;
    case 2:
    case "SCHEMA":
      return DataWarehouseObjectType.SCHEMA;
    case 3:
    case "TABLE":
      return DataWarehouseObjectType.TABLE;
    case 4:
    case "COLUMN":
      return DataWarehouseObjectType.COLUMN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataWarehouseObjectType.UNRECOGNIZED;
  }
}

export function dataWarehouseObjectTypeToJSON(object: DataWarehouseObjectType): string {
  switch (object) {
    case DataWarehouseObjectType.INVALID_DATA_WAREHOUSE_OBJECT_TYPE:
      return "INVALID_DATA_WAREHOUSE_OBJECT_TYPE";
    case DataWarehouseObjectType.DATABASE:
      return "DATABASE";
    case DataWarehouseObjectType.SCHEMA:
      return "SCHEMA";
    case DataWarehouseObjectType.TABLE:
      return "TABLE";
    case DataWarehouseObjectType.COLUMN:
      return "COLUMN";
    case DataWarehouseObjectType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AuthenticationType {
  INVALID_AUTHENTICATION_TYPE = 0,
  SERVICE_ACCOUNT = 1,
  OAUTH = 2,
  IAM = 3,
  EXTOAUTH = 4,
  OAUTH_WITH_SERVICE_PRINCIPAL = 5,
  PERSONAL_ACCESS_TOKEN = 6,
  UNRECOGNIZED = -1,
}

export function authenticationTypeFromJSON(object: any): AuthenticationType {
  switch (object) {
    case 0:
    case "INVALID_AUTHENTICATION_TYPE":
      return AuthenticationType.INVALID_AUTHENTICATION_TYPE;
    case 1:
    case "SERVICE_ACCOUNT":
      return AuthenticationType.SERVICE_ACCOUNT;
    case 2:
    case "OAUTH":
      return AuthenticationType.OAUTH;
    case 3:
    case "IAM":
      return AuthenticationType.IAM;
    case 4:
    case "EXTOAUTH":
      return AuthenticationType.EXTOAUTH;
    case 5:
    case "OAUTH_WITH_SERVICE_PRINCIPAL":
      return AuthenticationType.OAUTH_WITH_SERVICE_PRINCIPAL;
    case 6:
    case "PERSONAL_ACCESS_TOKEN":
      return AuthenticationType.PERSONAL_ACCESS_TOKEN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthenticationType.UNRECOGNIZED;
  }
}

export function authenticationTypeToJSON(object: AuthenticationType): string {
  switch (object) {
    case AuthenticationType.INVALID_AUTHENTICATION_TYPE:
      return "INVALID_AUTHENTICATION_TYPE";
    case AuthenticationType.SERVICE_ACCOUNT:
      return "SERVICE_ACCOUNT";
    case AuthenticationType.OAUTH:
      return "OAUTH";
    case AuthenticationType.IAM:
      return "IAM";
    case AuthenticationType.EXTOAUTH:
      return "EXTOAUTH";
    case AuthenticationType.OAUTH_WITH_SERVICE_PRINCIPAL:
      return "OAUTH_WITH_SERVICE_PRINCIPAL";
    case AuthenticationType.PERSONAL_ACCESS_TOKEN:
      return "PERSONAL_ACCESS_TOKEN";
    case AuthenticationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ImportPolicy {
  INVALID_IMPORT_POLICY = 0,
  PARTIAL = 1,
  ALL_OR_NONE = 2,
  VALIDATE_ONLY = 3,
  PARTIAL_OBJECT = 4,
  UNRECOGNIZED = -1,
}

export function importPolicyFromJSON(object: any): ImportPolicy {
  switch (object) {
    case 0:
    case "INVALID_IMPORT_POLICY":
      return ImportPolicy.INVALID_IMPORT_POLICY;
    case 1:
    case "PARTIAL":
      return ImportPolicy.PARTIAL;
    case 2:
    case "ALL_OR_NONE":
      return ImportPolicy.ALL_OR_NONE;
    case 3:
    case "VALIDATE_ONLY":
      return ImportPolicy.VALIDATE_ONLY;
    case 4:
    case "PARTIAL_OBJECT":
      return ImportPolicy.PARTIAL_OBJECT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ImportPolicy.UNRECOGNIZED;
  }
}

export function importPolicyToJSON(object: ImportPolicy): string {
  switch (object) {
    case ImportPolicy.INVALID_IMPORT_POLICY:
      return "INVALID_IMPORT_POLICY";
    case ImportPolicy.PARTIAL:
      return "PARTIAL";
    case ImportPolicy.ALL_OR_NONE:
      return "ALL_OR_NONE";
    case ImportPolicy.VALIDATE_ONLY:
      return "VALIDATE_ONLY";
    case ImportPolicy.PARTIAL_OBJECT:
      return "PARTIAL_OBJECT";
    case ImportPolicy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Request body parameters for the login API.
 * Endpoint:: POST /api/rest/2.0/auth/session/login
 */
export interface LoginRequest {
  /** Username of the ThoughtSpot user. */
  username?:
    | string
    | undefined;
  /** Password of the user account. */
  password?:
    | string
    | undefined;
  /**
   * Id of the Org context to log in to. If Org ID is not specified,
   * the user will be logged in to the Org context of their previous login session.
   */
  org_identifier?:
    | string
    | undefined;
  /**
   * A flag to remember the user session. When set to true,
   * a session cookie is created and used in subsequent API requests.
   * Default value is false.
   */
  remember_me?: boolean | undefined;
}

/**
 * Request body parameters for the TML export API.
 * Endpoint:: POST /api/rest/2.0/metadata/tml/export
 */
export interface TMLExportRequest {
  /** List of metadata objects to export. */
  metadata: TMLExportRequest_Metadata[];
  /**
   * Indicates whether to export associated metadata objects of specified metadata objects.
   * Default value is false.
   */
  export_associated?:
    | boolean
    | undefined;
  /**
   * Adds FQNs of the referenced objects.
   * For example, if you are exporting a Liveboard and its associated objects,
   * the API returns the Liveboard TML data with the FQNs of the referenced worksheet.
   * Default value is false;
   */
  export_fqn?:
    | boolean
    | undefined;
  /** Indicates whether to export table while exporting connection. */
  export_dependent?:
    | boolean
    | undefined;
  /**
   * TML EDOC content format.
   * Default is JSON.
   */
  edoc_format?: TMLExportRequest_EdocFormat | undefined;
}

/** Type of ThoughtSpot metadata object. */
export enum TMLExportRequest_MetadataType {
  LIVEBOARD = 0,
  ANSWER = 1,
  LOGICAL_TABLE = 2,
  CONNECTION = 3,
  CUSTOM_ACTION = 4,
  UNRECOGNIZED = -1,
}

export function tMLExportRequest_MetadataTypeFromJSON(object: any): TMLExportRequest_MetadataType {
  switch (object) {
    case 0:
    case "LIVEBOARD":
      return TMLExportRequest_MetadataType.LIVEBOARD;
    case 1:
    case "ANSWER":
      return TMLExportRequest_MetadataType.ANSWER;
    case 2:
    case "LOGICAL_TABLE":
      return TMLExportRequest_MetadataType.LOGICAL_TABLE;
    case 3:
    case "CONNECTION":
      return TMLExportRequest_MetadataType.CONNECTION;
    case 4:
    case "CUSTOM_ACTION":
      return TMLExportRequest_MetadataType.CUSTOM_ACTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TMLExportRequest_MetadataType.UNRECOGNIZED;
  }
}

export function tMLExportRequest_MetadataTypeToJSON(object: TMLExportRequest_MetadataType): string {
  switch (object) {
    case TMLExportRequest_MetadataType.LIVEBOARD:
      return "LIVEBOARD";
    case TMLExportRequest_MetadataType.ANSWER:
      return "ANSWER";
    case TMLExportRequest_MetadataType.LOGICAL_TABLE:
      return "LOGICAL_TABLE";
    case TMLExportRequest_MetadataType.CONNECTION:
      return "CONNECTION";
    case TMLExportRequest_MetadataType.CUSTOM_ACTION:
      return "CUSTOM_ACTION";
    case TMLExportRequest_MetadataType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Format of the TML export response. */
export enum TMLExportRequest_EdocFormat {
  JSON = 0,
  YAML = 1,
  UNRECOGNIZED = -1,
}

export function tMLExportRequest_EdocFormatFromJSON(object: any): TMLExportRequest_EdocFormat {
  switch (object) {
    case 0:
    case "JSON":
      return TMLExportRequest_EdocFormat.JSON;
    case 1:
    case "YAML":
      return TMLExportRequest_EdocFormat.YAML;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TMLExportRequest_EdocFormat.UNRECOGNIZED;
  }
}

export function tMLExportRequest_EdocFormatToJSON(object: TMLExportRequest_EdocFormat): string {
  switch (object) {
    case TMLExportRequest_EdocFormat.JSON:
      return "JSON";
    case TMLExportRequest_EdocFormat.YAML:
      return "YAML";
    case TMLExportRequest_EdocFormat.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Metadata objects to export. */
export interface TMLExportRequest_Metadata {
  /** Type of metadata object. */
  type?:
    | TMLExportRequest_MetadataType
    | undefined;
  /** Unique ID of the metadata object. */
  identifier?: string | undefined;
}

/**
 * Response of the tml export for one metadata object.
 * The actual response of /tml/export is an array of this response.
 */
export interface TMLExportResponse {
  /** Json string of the TML representation of the requested metadata object. */
  edoc?: string | undefined;
  info?: TMLInfo | undefined;
}

/** Information about the TML export of a metadata object from ThoughtSpot. */
export interface TMLInfo {
  /** Name of the tml file. */
  filename?:
    | string
    | undefined;
  /** Name of the metadata object. */
  name?:
    | string
    | undefined;
  /** GUID of the metadata object. */
  id?:
    | string
    | undefined;
  /**
   * Field telling whether response is TML of worksheet or table.
   * Type of the metadata object - answer, liveboard, worksheet, table.
   */
  type?:
    | string
    | undefined;
  /**
   * TML info of the associated/dependent objects of this metadata object.
   * This is set when `export_associated = true` in the tml export request.
   */
  dependency: TMLInfo[];
  /** Status of the TML export. */
  status?: TMLInfo_TMLStatus | undefined;
}

/**
 * Status of worksheet (don't know what its supposed to mean, but should be "ok").
 * Status of TML export.
 */
export interface TMLInfo_TMLStatus {
  /**
   * For success, the status code will be "OK".
   * For failure, the status code will be "ERROR".
   */
  status_code?:
    | string
    | undefined;
  /** For failure status, error message is present to indicate what was the error. */
  error_message?: string | undefined;
}

/**
 * Request body parameter for the Search Data API.
 * Endpoint:: POST /api/rest/2.0/searchdata
 * Details of how to create the search query string in given here:
 * https://developers.thoughtspot.com/docs/fetch-data-and-report-apis#_search_data_api
 */
export interface SearchDataRequest {
  /**
   * TS search data string used for querying the worksheet.
   * Format :
   *    Columns of the worksheet - [<name of col>]
   *    Bucketing - [<name of col>].<bucket>
   *    Sorting - sort by [<name of col>] <ascending/descending>
   *    Aggregation
   *      GROWTH - growth of [<name of col>] by [<name of col>]
   *      Other agg - <agg> [<name of col>]
   *    Filter
   *      varchar, int32, int64, double - '<value>'
   *      date - 'MM/DD/YYYY', '<full month> <year>'
   *      boolean - ?
   *      datetime - ?
   */
  query_string?:
    | string
    | undefined;
  /** Guid of the worksheet. */
  logical_table_identifier?:
    | string
    | undefined;
  /**
   * JSON output format.
   * Possible values - COMPACT
   * Default value - COMPACT
   */
  data_format?:
    | string
    | undefined;
  /** Row offset while sending the rows of data. Kept as 0. */
  record_offset?:
    | number
    | undefined;
  /** Number of rows to fetch. Stored in DEFAULT_RECORD_SIZE. */
  record_size?: number | undefined;
}

/** Response structure for the /searchdata API from ThoughtSpot. */
export interface SearchDataResponse {
  /** Search data response may consist of multiple datasets. */
  contents: SearchDataResponse_Content[];
}

/** Content corresponds to a single dataset in the search query response. */
export interface SearchDataResponse_Content {
  /** Total number of rows available in this dataset. */
  available_data_row_count?:
    | number
    | undefined;
  /** Ordered list of column names in the dataset. */
  column_names: string[];
  /**
   * 'data_rows' from TS response cannot be parsed in proto as the values are returned
   * as array of rows, where every row is an array of primitives, which we can't
   * know beforehand. For example -
   * [["OE Adult",234.80,1710761474],["OE Jr",259.25,1710761474]]
   * repeated string data_rows = 3;
   * So, we manually parse the json response and set the data_rows_array.
   * This is an array of strings where each string corresponds to a json array of row values.
   */
  data_rows_array: string[];
  /** Offset of the current batch of records. */
  record_offset?:
    | number
    | undefined;
  /** Maximum number of records requested. */
  record_size?:
    | number
    | undefined;
  /** Number of records returned in this response. */
  returned_data_row_count?:
    | number
    | undefined;
  /** Sampling ratio if the dataset. */
  sampling_ratio?: number | undefined;
}

/** EDOC is the container of TML representation of ThoughtSpot objects. */
export interface ThoughtSpotEDOC {
  /** Id of the edoc object. */
  guid?:
    | string
    | undefined;
  /** Type of the edoc object. */
  type?:
    | ThoughtSpotEDOC_EdocType
    | undefined;
  /** One of the following will be set based on the edoc type. */
  worksheet?: WorksheetTML | undefined;
  table?: TableTML | undefined;
  model?: ModelTML | undefined;
  sql_view?: SQLViewTML | undefined;
}

/** Type of edoc. */
export enum ThoughtSpotEDOC_EdocType {
  LIVEBOARD = 0,
  ANSWER = 1,
  WORKSHEET = 2,
  TABLE = 3,
  MODEL = 4,
  CONNECTION = 5,
  SQL_VIEW = 6,
  UNRECOGNIZED = -1,
}

export function thoughtSpotEDOC_EdocTypeFromJSON(object: any): ThoughtSpotEDOC_EdocType {
  switch (object) {
    case 0:
    case "LIVEBOARD":
      return ThoughtSpotEDOC_EdocType.LIVEBOARD;
    case 1:
    case "ANSWER":
      return ThoughtSpotEDOC_EdocType.ANSWER;
    case 2:
    case "WORKSHEET":
      return ThoughtSpotEDOC_EdocType.WORKSHEET;
    case 3:
    case "TABLE":
      return ThoughtSpotEDOC_EdocType.TABLE;
    case 4:
    case "MODEL":
      return ThoughtSpotEDOC_EdocType.MODEL;
    case 5:
    case "CONNECTION":
      return ThoughtSpotEDOC_EdocType.CONNECTION;
    case 6:
    case "SQL_VIEW":
      return ThoughtSpotEDOC_EdocType.SQL_VIEW;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ThoughtSpotEDOC_EdocType.UNRECOGNIZED;
  }
}

export function thoughtSpotEDOC_EdocTypeToJSON(object: ThoughtSpotEDOC_EdocType): string {
  switch (object) {
    case ThoughtSpotEDOC_EdocType.LIVEBOARD:
      return "LIVEBOARD";
    case ThoughtSpotEDOC_EdocType.ANSWER:
      return "ANSWER";
    case ThoughtSpotEDOC_EdocType.WORKSHEET:
      return "WORKSHEET";
    case ThoughtSpotEDOC_EdocType.TABLE:
      return "TABLE";
    case ThoughtSpotEDOC_EdocType.MODEL:
      return "MODEL";
    case ThoughtSpotEDOC_EdocType.CONNECTION:
      return "CONNECTION";
    case ThoughtSpotEDOC_EdocType.SQL_VIEW:
      return "SQL_VIEW";
    case ThoughtSpotEDOC_EdocType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Column in the worksheet or model. */
export interface TSModelColumn {
  /** Name of the worksheet / model column. */
  name?:
    | string
    | undefined;
  /** Description of the worksheet / model column. */
  description?:
    | string
    | undefined;
  /** Properties of the worksheet / model column. */
  properties?:
    | ColumnProperties
    | undefined;
  /**
   * Unique id of the worksheet / model column.
   * Format of column_id: <id>::<name>
   * <id> comes from WorksheetTML.TablePath.id, and <name> comes from TableTML.TableColumn.name
   * For example: column_id = Customer_Dimension::Customer_Name
   */
  column_id?:
    | string
    | undefined;
  /**
   * Id of the reference worksheet / model formula.
   * formula_id refers to TSModelFormula.name
   * @Constraint: Only one of column_id or formula_id is set.
   */
  formula_id?:
    | string
    | undefined;
  /** Name of the output column as per the SELECT clause in the view’s SQL query. */
  sql_output_column?: string | undefined;
}

/** Underlying table or view in the worksheet or model. */
export interface TSModelTable {
  /** Name if the unique identifier of the table. */
  name?:
    | string
    | undefined;
  /** Optional id of the table. */
  id?:
    | string
    | undefined;
  /** GUID of the table in ThoughtSpot. */
  fqn?:
    | string
    | undefined;
  /** Optional alias for the table, used as an alternative name. */
  alias?: string | undefined;
}

/** Formula in the worksheet or model. */
export interface TSModelFormula {
  /** Name of the formula. */
  name?:
    | string
    | undefined;
  /** Id of the formula */
  id?:
    | string
    | undefined;
  /** Formula expression in ThoughtSpot formula language. */
  expr?: string | undefined;
}

/**
 * TML representation of ThoughtSpot worksheet.
 * Documentation of worksheet TML - https://docs.thoughtspot.com/cloud/latest/tml-worksheets
 */
export interface WorksheetTML {
  /** Name of the worksheet. */
  name?:
    | string
    | undefined;
  /** Description of the worksheet. */
  description?:
    | string
    | undefined;
  /** List of all columns in the worksheet. */
  worksheet_columns: TSModelColumn[];
  /**
   * List of formulas defined in the worksheet.
   * This can be used to find which underlying tables/columns is the formula dependent on.
   */
  formulas: TSModelFormula[];
  /**
   * List of underlying tables/views in the worksheet.
   * This can be used to find if the attributes across data models come from the common dimension.
   * For ex - There is a worksheet for "Revenue" containing reference to Location dimension, and
   *          another one for "Cash Receipts" containing reference to the same Location dimension.
   *          Although the worksheet columns are different across data models, but looking at the
   *          same underlying table, we can say that both the columns are same attributes.
   */
  tables: TSModelTable[];
  /** List of table paths used in the worksheet. */
  table_paths: WorksheetTML_TablePath[];
}

/** Join path used to reach the table while querying the worksheet. */
export interface WorksheetTML_TablePath {
  id?:
    | string
    | undefined;
  /**
   * Unique identifier of the destination table.
   * This corresponds to Table.name field.
   */
  table?: string | undefined;
}

/**
 * TML representation of a Model in ThoughtSpot.
 * Documentation of worksheet TML - https://docs.thoughtspot.com/cloud/latest/tml-models
 */
export interface ModelTML {
  /** Name of the model. */
  name?:
    | string
    | undefined;
  /** Description of the model. */
  description?:
    | string
    | undefined;
  /** List of tables used in the model. */
  model_tables: TSModelTable[];
  /** List of columns defined in the model. */
  columns: TSModelColumn[];
  /** List of formulas defined in the model. */
  formulas: TSModelFormula[];
}

/**
 * TML representation of a table in ThoughtSpot.
 * Documentation of worksheet TML - https://docs.thoughtspot.com/cloud/latest/tml-tables
 */
export interface TableTML {
  /** Name of the table. */
  name?:
    | string
    | undefined;
  /** Description of the table. */
  description?:
    | string
    | undefined;
  /** The database that a table resides in. */
  db?:
    | string
    | undefined;
  /** The schema that the table is a part of. */
  schema?:
    | string
    | undefined;
  /** The name of the table in the database. */
  db_table?:
    | string
    | undefined;
  /** External data warehouse connection that the table or column resides in. */
  connection?:
    | Connection
    | undefined;
  /** List of all columns in the table. */
  columns: TableTML_TableColumn[];
}

/** Column in the table. */
export interface TableTML_TableColumn {
  /** Name of the column. */
  name?:
    | string
    | undefined;
  /** Name of the column in the database. */
  db_column_name?:
    | string
    | undefined;
  /** Properties of the table column. */
  properties?:
    | ColumnProperties
    | undefined;
  /** The properties of the column in the database. */
  db_column_properties?:
    | TableTML_TableColumn_DatabaseColumnProperties
    | undefined;
  /** Either use this data type or from the db column properties. */
  data_type?: string | undefined;
}

/** Properties of the column in the database. */
export interface TableTML_TableColumn_DatabaseColumnProperties {
  /**
   * Data type of the column.
   * Possible values: BOOL | VARCHAR | DOUBLE | FLOAT | INT32 | INT64 | DATE | TIME
   */
  data_type?: string | undefined;
}

/** Identifier of the external data warehouse connection. */
export interface Connection {
  name?: string | undefined;
  id?: string | undefined;
  fqn?: string | undefined;
}

/** Properties of a table/worksheet column in ThoughtSpot. */
export interface ColumnProperties {
  /**
   * The type of data the column represents.
   * Possible values: MEASURE or ATTRIBUTE.
   * The default is: MEASURE.
   */
  column_type?:
    | string
    | undefined;
  /**
   * The default aggregation of the worksheet column, depending on the data type.
   * Possible values - NONE, SUM, COUNT, AVERAGE, MAX, MIN,
   *                   COUNT_DISTINCT, STD_DEVIATION, VARIANCE
   * Default value is SUM.
   */
  aggregation?:
    | string
    | undefined;
  /**
   * Alternate names for the column, used in search.
   * NOTE: We are using this field to mark whether a column is a metric.
   */
  synonyms: string[];
}

/**
 * TML representation of SQL View in ThoughtSpot.
 * Documentation of SQL View TML - https://docs.thoughtspot.com/cloud/latest/tml-sql-views
 */
export interface SQLViewTML {
  /** Name of the view. */
  name?:
    | string
    | undefined;
  /** Description of the view. */
  description?:
    | string
    | undefined;
  /** External data warehouse connection that the view is created from. */
  connection?:
    | Connection
    | undefined;
  /** SQL query string used to create the view. */
  sql_query?:
    | string
    | undefined;
  /** List of columns defined in the model. */
  sql_view_columns: TSModelColumn[];
}

export interface CreateUpdateConnectionRequest {
  /** Name of the connection */
  name?:
    | string
    | undefined;
  /** Optional description */
  description?:
    | string
    | undefined;
  /** Type of data warehouse. */
  data_warehouse_type?:
    | DataWarehouseType
    | undefined;
  /** JSON string containing connection metadata */
  data_warehouse_config?:
    | string
    | undefined;
  /**
   * Validates the connection metadata if tables are included.
   * If you are creating a connection without tables, specify false.
   */
  validate?: boolean | undefined;
}

export interface CreateConnectionResponse {
  id?: string | undefined;
  name?: string | undefined;
  data_warehouse_type?: DataWarehouseType | undefined;
}

export interface DataWarehouseObjectInput {
  database?: string | undefined;
  schema?: string | undefined;
  table?: string | undefined;
  column?: string | undefined;
}

export interface ConnectionInput {
  identifier?: string | undefined;
  name_pattern?: string | undefined;
  data_warehouse_objects: DataWarehouseObjectInput[];
}

export interface SearchConnectionRequest {
  /** List of connections and name pattern */
  connections: ConnectionInput[];
  /** The starting record number from where the records should be included. Default: 0 */
  record_offset?:
    | number
    | undefined;
  /** The number of records that should be included. in our case we are sending -1. */
  record_size?:
    | number
    | undefined;
  /**
   * Data warehouse object type to fetch the data till that level. If this is set to DATABASE, then
   * we will only get the name of databases in the connection, and if set to COLUMN, then we will
   * get all the databases, schemas, tables and its columns in the response.
   */
  data_warehouse_object_type?:
    | DataWarehouseObjectType
    | undefined;
  /** Indicates whether to include complete details of the connection objects. */
  include_details?: boolean | undefined;
}

export interface Column {
  name?: string | undefined;
  data_type?: string | undefined;
  is_aggregate?: string | undefined;
  can_import?: boolean | undefined;
  selected?: boolean | undefined;
  is_linked_active?: boolean | undefined;
}

export interface Table {
  name?: string | undefined;
  columns: Column[];
  type?: string | undefined;
  description?: string | undefined;
  selected?: boolean | undefined;
  linked?:
    | boolean
    | undefined;
  /** JsonArray denoting relationships of this table. */
  relationships: string[];
}

export interface Schema {
  name?: string | undefined;
  tables: Table[];
}

export interface Database {
  name?: string | undefined;
  schemas: Schema[];
  auto_created?: boolean | undefined;
}

export interface DataWarehouseObject {
  databases: Database[];
}

export interface SearchConnectionResponse {
  id?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  data_warehouse_type?: DataWarehouseType | undefined;
  data_warehouse_objects?: DataWarehouseObject | undefined;
}

export interface TMLImportRequest {
  /** Details of TML objects. */
  metadata_tmls: string[];
  /** Specifies the import policy for the TML import. */
  import_policy?:
    | ImportPolicy
    | undefined;
  /** If selected, creates TML objects with new GUIDs. */
  create_new?: boolean | undefined;
}

export interface TMLImportResponse {
  response?: TMLImportResponse_TMLResponseEntity | undefined;
  request_index?: number | undefined;
}

export interface TMLImportResponse_TMLImportResponseHeader {
  author_name?: string | undefined;
  author_guid?: string | undefined;
  id_guid?:
    | string
    | undefined;
  /** For table, it is set to LOGICAL_TABLE. */
  metadata_type?: string | undefined;
  name?:
    | string
    | undefined;
  /** this is set to WORKSHEET. */
  type?: string | undefined;
}

export interface TMLImportResponse_Status {
  status_code?: string | undefined;
  error_message?: string | undefined;
}

export interface TMLImportResponse_TMLResponseEntity {
  header?: TMLImportResponse_TMLImportResponseHeader | undefined;
  status?: TMLImportResponse_Status | undefined;
}

export interface CreateDataModelResponse {
  model_id?: string | undefined;
  model_name?: string | undefined;
  error_message?: string | undefined;
}

function createBaseLoginRequest(): LoginRequest {
  return { username: undefined, password: undefined, org_identifier: undefined, remember_me: undefined };
}

export const LoginRequest: MessageFns<LoginRequest> = {
  encode(message: LoginRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.username !== undefined) {
      writer.uint32(10).string(message.username);
    }
    if (message.password !== undefined) {
      writer.uint32(18).string(message.password);
    }
    if (message.org_identifier !== undefined) {
      writer.uint32(26).string(message.org_identifier);
    }
    if (message.remember_me !== undefined) {
      writer.uint32(32).bool(message.remember_me);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoginRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoginRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.username = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.org_identifier = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.remember_me = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoginRequest {
    return {
      username: isSet(object.username) ? globalThis.String(object.username) : undefined,
      password: isSet(object.password) ? globalThis.String(object.password) : undefined,
      org_identifier: isSet(object.org_identifier) ? globalThis.String(object.org_identifier) : undefined,
      remember_me: isSet(object.remember_me) ? globalThis.Boolean(object.remember_me) : undefined,
    };
  },

  toJSON(message: LoginRequest): unknown {
    const obj: any = {};
    if (message.username !== undefined) {
      obj.username = message.username;
    }
    if (message.password !== undefined) {
      obj.password = message.password;
    }
    if (message.org_identifier !== undefined) {
      obj.org_identifier = message.org_identifier;
    }
    if (message.remember_me !== undefined) {
      obj.remember_me = message.remember_me;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoginRequest>, I>>(base?: I): LoginRequest {
    return LoginRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoginRequest>, I>>(object: I): LoginRequest {
    const message = createBaseLoginRequest();
    message.username = object.username ?? undefined;
    message.password = object.password ?? undefined;
    message.org_identifier = object.org_identifier ?? undefined;
    message.remember_me = object.remember_me ?? undefined;
    return message;
  },
};

function createBaseTMLExportRequest(): TMLExportRequest {
  return {
    metadata: [],
    export_associated: undefined,
    export_fqn: undefined,
    export_dependent: undefined,
    edoc_format: undefined,
  };
}

export const TMLExportRequest: MessageFns<TMLExportRequest> = {
  encode(message: TMLExportRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.metadata) {
      TMLExportRequest_Metadata.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.export_associated !== undefined) {
      writer.uint32(16).bool(message.export_associated);
    }
    if (message.export_fqn !== undefined) {
      writer.uint32(24).bool(message.export_fqn);
    }
    if (message.export_dependent !== undefined) {
      writer.uint32(32).bool(message.export_dependent);
    }
    if (message.edoc_format !== undefined) {
      writer.uint32(40).int32(message.edoc_format);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TMLExportRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTMLExportRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata.push(TMLExportRequest_Metadata.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.export_associated = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.export_fqn = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.export_dependent = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.edoc_format = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TMLExportRequest {
    return {
      metadata: globalThis.Array.isArray(object?.metadata)
        ? object.metadata.map((e: any) => TMLExportRequest_Metadata.fromJSON(e))
        : [],
      export_associated: isSet(object.export_associated) ? globalThis.Boolean(object.export_associated) : undefined,
      export_fqn: isSet(object.export_fqn) ? globalThis.Boolean(object.export_fqn) : undefined,
      export_dependent: isSet(object.export_dependent) ? globalThis.Boolean(object.export_dependent) : undefined,
      edoc_format: isSet(object.edoc_format) ? tMLExportRequest_EdocFormatFromJSON(object.edoc_format) : undefined,
    };
  },

  toJSON(message: TMLExportRequest): unknown {
    const obj: any = {};
    if (message.metadata?.length) {
      obj.metadata = message.metadata.map((e) => TMLExportRequest_Metadata.toJSON(e));
    }
    if (message.export_associated !== undefined) {
      obj.export_associated = message.export_associated;
    }
    if (message.export_fqn !== undefined) {
      obj.export_fqn = message.export_fqn;
    }
    if (message.export_dependent !== undefined) {
      obj.export_dependent = message.export_dependent;
    }
    if (message.edoc_format !== undefined) {
      obj.edoc_format = tMLExportRequest_EdocFormatToJSON(message.edoc_format);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TMLExportRequest>, I>>(base?: I): TMLExportRequest {
    return TMLExportRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TMLExportRequest>, I>>(object: I): TMLExportRequest {
    const message = createBaseTMLExportRequest();
    message.metadata = object.metadata?.map((e) => TMLExportRequest_Metadata.fromPartial(e)) || [];
    message.export_associated = object.export_associated ?? undefined;
    message.export_fqn = object.export_fqn ?? undefined;
    message.export_dependent = object.export_dependent ?? undefined;
    message.edoc_format = object.edoc_format ?? undefined;
    return message;
  },
};

function createBaseTMLExportRequest_Metadata(): TMLExportRequest_Metadata {
  return { type: undefined, identifier: undefined };
}

export const TMLExportRequest_Metadata: MessageFns<TMLExportRequest_Metadata> = {
  encode(message: TMLExportRequest_Metadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(8).int32(message.type);
    }
    if (message.identifier !== undefined) {
      writer.uint32(18).string(message.identifier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TMLExportRequest_Metadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTMLExportRequest_Metadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.identifier = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TMLExportRequest_Metadata {
    return {
      type: isSet(object.type) ? tMLExportRequest_MetadataTypeFromJSON(object.type) : undefined,
      identifier: isSet(object.identifier) ? globalThis.String(object.identifier) : undefined,
    };
  },

  toJSON(message: TMLExportRequest_Metadata): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = tMLExportRequest_MetadataTypeToJSON(message.type);
    }
    if (message.identifier !== undefined) {
      obj.identifier = message.identifier;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TMLExportRequest_Metadata>, I>>(base?: I): TMLExportRequest_Metadata {
    return TMLExportRequest_Metadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TMLExportRequest_Metadata>, I>>(object: I): TMLExportRequest_Metadata {
    const message = createBaseTMLExportRequest_Metadata();
    message.type = object.type ?? undefined;
    message.identifier = object.identifier ?? undefined;
    return message;
  },
};

function createBaseTMLExportResponse(): TMLExportResponse {
  return { edoc: undefined, info: undefined };
}

export const TMLExportResponse: MessageFns<TMLExportResponse> = {
  encode(message: TMLExportResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.edoc !== undefined) {
      writer.uint32(10).string(message.edoc);
    }
    if (message.info !== undefined) {
      TMLInfo.encode(message.info, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TMLExportResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTMLExportResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.edoc = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.info = TMLInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TMLExportResponse {
    return {
      edoc: isSet(object.edoc) ? globalThis.String(object.edoc) : undefined,
      info: isSet(object.info) ? TMLInfo.fromJSON(object.info) : undefined,
    };
  },

  toJSON(message: TMLExportResponse): unknown {
    const obj: any = {};
    if (message.edoc !== undefined) {
      obj.edoc = message.edoc;
    }
    if (message.info !== undefined) {
      obj.info = TMLInfo.toJSON(message.info);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TMLExportResponse>, I>>(base?: I): TMLExportResponse {
    return TMLExportResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TMLExportResponse>, I>>(object: I): TMLExportResponse {
    const message = createBaseTMLExportResponse();
    message.edoc = object.edoc ?? undefined;
    message.info = (object.info !== undefined && object.info !== null) ? TMLInfo.fromPartial(object.info) : undefined;
    return message;
  },
};

function createBaseTMLInfo(): TMLInfo {
  return { filename: undefined, name: undefined, id: undefined, type: undefined, dependency: [], status: undefined };
}

export const TMLInfo: MessageFns<TMLInfo> = {
  encode(message: TMLInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filename !== undefined) {
      writer.uint32(10).string(message.filename);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.id !== undefined) {
      writer.uint32(26).string(message.id);
    }
    if (message.type !== undefined) {
      writer.uint32(34).string(message.type);
    }
    for (const v of message.dependency) {
      TMLInfo.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.status !== undefined) {
      TMLInfo_TMLStatus.encode(message.status, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TMLInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTMLInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.dependency.push(TMLInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.status = TMLInfo_TMLStatus.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TMLInfo {
    return {
      filename: isSet(object.filename) ? globalThis.String(object.filename) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      type: isSet(object.type) ? globalThis.String(object.type) : undefined,
      dependency: globalThis.Array.isArray(object?.dependency)
        ? object.dependency.map((e: any) => TMLInfo.fromJSON(e))
        : [],
      status: isSet(object.status) ? TMLInfo_TMLStatus.fromJSON(object.status) : undefined,
    };
  },

  toJSON(message: TMLInfo): unknown {
    const obj: any = {};
    if (message.filename !== undefined) {
      obj.filename = message.filename;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.type !== undefined) {
      obj.type = message.type;
    }
    if (message.dependency?.length) {
      obj.dependency = message.dependency.map((e) => TMLInfo.toJSON(e));
    }
    if (message.status !== undefined) {
      obj.status = TMLInfo_TMLStatus.toJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TMLInfo>, I>>(base?: I): TMLInfo {
    return TMLInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TMLInfo>, I>>(object: I): TMLInfo {
    const message = createBaseTMLInfo();
    message.filename = object.filename ?? undefined;
    message.name = object.name ?? undefined;
    message.id = object.id ?? undefined;
    message.type = object.type ?? undefined;
    message.dependency = object.dependency?.map((e) => TMLInfo.fromPartial(e)) || [];
    message.status = (object.status !== undefined && object.status !== null)
      ? TMLInfo_TMLStatus.fromPartial(object.status)
      : undefined;
    return message;
  },
};

function createBaseTMLInfo_TMLStatus(): TMLInfo_TMLStatus {
  return { status_code: undefined, error_message: undefined };
}

export const TMLInfo_TMLStatus: MessageFns<TMLInfo_TMLStatus> = {
  encode(message: TMLInfo_TMLStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status_code !== undefined) {
      writer.uint32(10).string(message.status_code);
    }
    if (message.error_message !== undefined) {
      writer.uint32(18).string(message.error_message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TMLInfo_TMLStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTMLInfo_TMLStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status_code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error_message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TMLInfo_TMLStatus {
    return {
      status_code: isSet(object.status_code) ? globalThis.String(object.status_code) : undefined,
      error_message: isSet(object.error_message) ? globalThis.String(object.error_message) : undefined,
    };
  },

  toJSON(message: TMLInfo_TMLStatus): unknown {
    const obj: any = {};
    if (message.status_code !== undefined) {
      obj.status_code = message.status_code;
    }
    if (message.error_message !== undefined) {
      obj.error_message = message.error_message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TMLInfo_TMLStatus>, I>>(base?: I): TMLInfo_TMLStatus {
    return TMLInfo_TMLStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TMLInfo_TMLStatus>, I>>(object: I): TMLInfo_TMLStatus {
    const message = createBaseTMLInfo_TMLStatus();
    message.status_code = object.status_code ?? undefined;
    message.error_message = object.error_message ?? undefined;
    return message;
  },
};

function createBaseSearchDataRequest(): SearchDataRequest {
  return {
    query_string: undefined,
    logical_table_identifier: undefined,
    data_format: undefined,
    record_offset: undefined,
    record_size: undefined,
  };
}

export const SearchDataRequest: MessageFns<SearchDataRequest> = {
  encode(message: SearchDataRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.query_string !== undefined) {
      writer.uint32(10).string(message.query_string);
    }
    if (message.logical_table_identifier !== undefined) {
      writer.uint32(18).string(message.logical_table_identifier);
    }
    if (message.data_format !== undefined) {
      writer.uint32(26).string(message.data_format);
    }
    if (message.record_offset !== undefined) {
      writer.uint32(32).int32(message.record_offset);
    }
    if (message.record_size !== undefined) {
      writer.uint32(40).int32(message.record_size);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchDataRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchDataRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.query_string = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.logical_table_identifier = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.data_format = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.record_offset = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.record_size = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchDataRequest {
    return {
      query_string: isSet(object.query_string) ? globalThis.String(object.query_string) : undefined,
      logical_table_identifier: isSet(object.logical_table_identifier)
        ? globalThis.String(object.logical_table_identifier)
        : undefined,
      data_format: isSet(object.data_format) ? globalThis.String(object.data_format) : undefined,
      record_offset: isSet(object.record_offset) ? globalThis.Number(object.record_offset) : undefined,
      record_size: isSet(object.record_size) ? globalThis.Number(object.record_size) : undefined,
    };
  },

  toJSON(message: SearchDataRequest): unknown {
    const obj: any = {};
    if (message.query_string !== undefined) {
      obj.query_string = message.query_string;
    }
    if (message.logical_table_identifier !== undefined) {
      obj.logical_table_identifier = message.logical_table_identifier;
    }
    if (message.data_format !== undefined) {
      obj.data_format = message.data_format;
    }
    if (message.record_offset !== undefined) {
      obj.record_offset = Math.round(message.record_offset);
    }
    if (message.record_size !== undefined) {
      obj.record_size = Math.round(message.record_size);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchDataRequest>, I>>(base?: I): SearchDataRequest {
    return SearchDataRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchDataRequest>, I>>(object: I): SearchDataRequest {
    const message = createBaseSearchDataRequest();
    message.query_string = object.query_string ?? undefined;
    message.logical_table_identifier = object.logical_table_identifier ?? undefined;
    message.data_format = object.data_format ?? undefined;
    message.record_offset = object.record_offset ?? undefined;
    message.record_size = object.record_size ?? undefined;
    return message;
  },
};

function createBaseSearchDataResponse(): SearchDataResponse {
  return { contents: [] };
}

export const SearchDataResponse: MessageFns<SearchDataResponse> = {
  encode(message: SearchDataResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.contents) {
      SearchDataResponse_Content.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchDataResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchDataResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.contents.push(SearchDataResponse_Content.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchDataResponse {
    return {
      contents: globalThis.Array.isArray(object?.contents)
        ? object.contents.map((e: any) => SearchDataResponse_Content.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SearchDataResponse): unknown {
    const obj: any = {};
    if (message.contents?.length) {
      obj.contents = message.contents.map((e) => SearchDataResponse_Content.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchDataResponse>, I>>(base?: I): SearchDataResponse {
    return SearchDataResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchDataResponse>, I>>(object: I): SearchDataResponse {
    const message = createBaseSearchDataResponse();
    message.contents = object.contents?.map((e) => SearchDataResponse_Content.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSearchDataResponse_Content(): SearchDataResponse_Content {
  return {
    available_data_row_count: undefined,
    column_names: [],
    data_rows_array: [],
    record_offset: undefined,
    record_size: undefined,
    returned_data_row_count: undefined,
    sampling_ratio: undefined,
  };
}

export const SearchDataResponse_Content: MessageFns<SearchDataResponse_Content> = {
  encode(message: SearchDataResponse_Content, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.available_data_row_count !== undefined) {
      writer.uint32(8).int32(message.available_data_row_count);
    }
    for (const v of message.column_names) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.data_rows_array) {
      writer.uint32(26).string(v!);
    }
    if (message.record_offset !== undefined) {
      writer.uint32(32).int32(message.record_offset);
    }
    if (message.record_size !== undefined) {
      writer.uint32(40).int32(message.record_size);
    }
    if (message.returned_data_row_count !== undefined) {
      writer.uint32(48).int32(message.returned_data_row_count);
    }
    if (message.sampling_ratio !== undefined) {
      writer.uint32(56).int32(message.sampling_ratio);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchDataResponse_Content {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchDataResponse_Content();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.available_data_row_count = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.column_names.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.data_rows_array.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.record_offset = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.record_size = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.returned_data_row_count = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.sampling_ratio = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchDataResponse_Content {
    return {
      available_data_row_count: isSet(object.available_data_row_count)
        ? globalThis.Number(object.available_data_row_count)
        : undefined,
      column_names: globalThis.Array.isArray(object?.column_names)
        ? object.column_names.map((e: any) => globalThis.String(e))
        : [],
      data_rows_array: globalThis.Array.isArray(object?.data_rows_array)
        ? object.data_rows_array.map((e: any) => globalThis.String(e))
        : [],
      record_offset: isSet(object.record_offset) ? globalThis.Number(object.record_offset) : undefined,
      record_size: isSet(object.record_size) ? globalThis.Number(object.record_size) : undefined,
      returned_data_row_count: isSet(object.returned_data_row_count)
        ? globalThis.Number(object.returned_data_row_count)
        : undefined,
      sampling_ratio: isSet(object.sampling_ratio) ? globalThis.Number(object.sampling_ratio) : undefined,
    };
  },

  toJSON(message: SearchDataResponse_Content): unknown {
    const obj: any = {};
    if (message.available_data_row_count !== undefined) {
      obj.available_data_row_count = Math.round(message.available_data_row_count);
    }
    if (message.column_names?.length) {
      obj.column_names = message.column_names;
    }
    if (message.data_rows_array?.length) {
      obj.data_rows_array = message.data_rows_array;
    }
    if (message.record_offset !== undefined) {
      obj.record_offset = Math.round(message.record_offset);
    }
    if (message.record_size !== undefined) {
      obj.record_size = Math.round(message.record_size);
    }
    if (message.returned_data_row_count !== undefined) {
      obj.returned_data_row_count = Math.round(message.returned_data_row_count);
    }
    if (message.sampling_ratio !== undefined) {
      obj.sampling_ratio = Math.round(message.sampling_ratio);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchDataResponse_Content>, I>>(base?: I): SearchDataResponse_Content {
    return SearchDataResponse_Content.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchDataResponse_Content>, I>>(object: I): SearchDataResponse_Content {
    const message = createBaseSearchDataResponse_Content();
    message.available_data_row_count = object.available_data_row_count ?? undefined;
    message.column_names = object.column_names?.map((e) => e) || [];
    message.data_rows_array = object.data_rows_array?.map((e) => e) || [];
    message.record_offset = object.record_offset ?? undefined;
    message.record_size = object.record_size ?? undefined;
    message.returned_data_row_count = object.returned_data_row_count ?? undefined;
    message.sampling_ratio = object.sampling_ratio ?? undefined;
    return message;
  },
};

function createBaseThoughtSpotEDOC(): ThoughtSpotEDOC {
  return {
    guid: undefined,
    type: undefined,
    worksheet: undefined,
    table: undefined,
    model: undefined,
    sql_view: undefined,
  };
}

export const ThoughtSpotEDOC: MessageFns<ThoughtSpotEDOC> = {
  encode(message: ThoughtSpotEDOC, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.guid !== undefined) {
      writer.uint32(10).string(message.guid);
    }
    if (message.type !== undefined) {
      writer.uint32(16).int32(message.type);
    }
    if (message.worksheet !== undefined) {
      WorksheetTML.encode(message.worksheet, writer.uint32(26).fork()).join();
    }
    if (message.table !== undefined) {
      TableTML.encode(message.table, writer.uint32(34).fork()).join();
    }
    if (message.model !== undefined) {
      ModelTML.encode(message.model, writer.uint32(42).fork()).join();
    }
    if (message.sql_view !== undefined) {
      SQLViewTML.encode(message.sql_view, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThoughtSpotEDOC {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThoughtSpotEDOC();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.guid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.worksheet = WorksheetTML.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.table = TableTML.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.model = ModelTML.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.sql_view = SQLViewTML.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThoughtSpotEDOC {
    return {
      guid: isSet(object.guid) ? globalThis.String(object.guid) : undefined,
      type: isSet(object.type) ? thoughtSpotEDOC_EdocTypeFromJSON(object.type) : undefined,
      worksheet: isSet(object.worksheet) ? WorksheetTML.fromJSON(object.worksheet) : undefined,
      table: isSet(object.table) ? TableTML.fromJSON(object.table) : undefined,
      model: isSet(object.model) ? ModelTML.fromJSON(object.model) : undefined,
      sql_view: isSet(object.sql_view) ? SQLViewTML.fromJSON(object.sql_view) : undefined,
    };
  },

  toJSON(message: ThoughtSpotEDOC): unknown {
    const obj: any = {};
    if (message.guid !== undefined) {
      obj.guid = message.guid;
    }
    if (message.type !== undefined) {
      obj.type = thoughtSpotEDOC_EdocTypeToJSON(message.type);
    }
    if (message.worksheet !== undefined) {
      obj.worksheet = WorksheetTML.toJSON(message.worksheet);
    }
    if (message.table !== undefined) {
      obj.table = TableTML.toJSON(message.table);
    }
    if (message.model !== undefined) {
      obj.model = ModelTML.toJSON(message.model);
    }
    if (message.sql_view !== undefined) {
      obj.sql_view = SQLViewTML.toJSON(message.sql_view);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ThoughtSpotEDOC>, I>>(base?: I): ThoughtSpotEDOC {
    return ThoughtSpotEDOC.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ThoughtSpotEDOC>, I>>(object: I): ThoughtSpotEDOC {
    const message = createBaseThoughtSpotEDOC();
    message.guid = object.guid ?? undefined;
    message.type = object.type ?? undefined;
    message.worksheet = (object.worksheet !== undefined && object.worksheet !== null)
      ? WorksheetTML.fromPartial(object.worksheet)
      : undefined;
    message.table = (object.table !== undefined && object.table !== null)
      ? TableTML.fromPartial(object.table)
      : undefined;
    message.model = (object.model !== undefined && object.model !== null)
      ? ModelTML.fromPartial(object.model)
      : undefined;
    message.sql_view = (object.sql_view !== undefined && object.sql_view !== null)
      ? SQLViewTML.fromPartial(object.sql_view)
      : undefined;
    return message;
  },
};

function createBaseTSModelColumn(): TSModelColumn {
  return {
    name: undefined,
    description: undefined,
    properties: undefined,
    column_id: undefined,
    formula_id: undefined,
    sql_output_column: undefined,
  };
}

export const TSModelColumn: MessageFns<TSModelColumn> = {
  encode(message: TSModelColumn, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    if (message.properties !== undefined) {
      ColumnProperties.encode(message.properties, writer.uint32(26).fork()).join();
    }
    if (message.column_id !== undefined) {
      writer.uint32(34).string(message.column_id);
    }
    if (message.formula_id !== undefined) {
      writer.uint32(42).string(message.formula_id);
    }
    if (message.sql_output_column !== undefined) {
      writer.uint32(50).string(message.sql_output_column);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TSModelColumn {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTSModelColumn();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.properties = ColumnProperties.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.column_id = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.formula_id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.sql_output_column = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TSModelColumn {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      properties: isSet(object.properties) ? ColumnProperties.fromJSON(object.properties) : undefined,
      column_id: isSet(object.column_id) ? globalThis.String(object.column_id) : undefined,
      formula_id: isSet(object.formula_id) ? globalThis.String(object.formula_id) : undefined,
      sql_output_column: isSet(object.sql_output_column) ? globalThis.String(object.sql_output_column) : undefined,
    };
  },

  toJSON(message: TSModelColumn): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.properties !== undefined) {
      obj.properties = ColumnProperties.toJSON(message.properties);
    }
    if (message.column_id !== undefined) {
      obj.column_id = message.column_id;
    }
    if (message.formula_id !== undefined) {
      obj.formula_id = message.formula_id;
    }
    if (message.sql_output_column !== undefined) {
      obj.sql_output_column = message.sql_output_column;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TSModelColumn>, I>>(base?: I): TSModelColumn {
    return TSModelColumn.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TSModelColumn>, I>>(object: I): TSModelColumn {
    const message = createBaseTSModelColumn();
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.properties = (object.properties !== undefined && object.properties !== null)
      ? ColumnProperties.fromPartial(object.properties)
      : undefined;
    message.column_id = object.column_id ?? undefined;
    message.formula_id = object.formula_id ?? undefined;
    message.sql_output_column = object.sql_output_column ?? undefined;
    return message;
  },
};

function createBaseTSModelTable(): TSModelTable {
  return { name: undefined, id: undefined, fqn: undefined, alias: undefined };
}

export const TSModelTable: MessageFns<TSModelTable> = {
  encode(message: TSModelTable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.id !== undefined) {
      writer.uint32(18).string(message.id);
    }
    if (message.fqn !== undefined) {
      writer.uint32(26).string(message.fqn);
    }
    if (message.alias !== undefined) {
      writer.uint32(34).string(message.alias);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TSModelTable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTSModelTable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fqn = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.alias = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TSModelTable {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      fqn: isSet(object.fqn) ? globalThis.String(object.fqn) : undefined,
      alias: isSet(object.alias) ? globalThis.String(object.alias) : undefined,
    };
  },

  toJSON(message: TSModelTable): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.fqn !== undefined) {
      obj.fqn = message.fqn;
    }
    if (message.alias !== undefined) {
      obj.alias = message.alias;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TSModelTable>, I>>(base?: I): TSModelTable {
    return TSModelTable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TSModelTable>, I>>(object: I): TSModelTable {
    const message = createBaseTSModelTable();
    message.name = object.name ?? undefined;
    message.id = object.id ?? undefined;
    message.fqn = object.fqn ?? undefined;
    message.alias = object.alias ?? undefined;
    return message;
  },
};

function createBaseTSModelFormula(): TSModelFormula {
  return { name: undefined, id: undefined, expr: undefined };
}

export const TSModelFormula: MessageFns<TSModelFormula> = {
  encode(message: TSModelFormula, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.id !== undefined) {
      writer.uint32(18).string(message.id);
    }
    if (message.expr !== undefined) {
      writer.uint32(26).string(message.expr);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TSModelFormula {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTSModelFormula();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.expr = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TSModelFormula {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      expr: isSet(object.expr) ? globalThis.String(object.expr) : undefined,
    };
  },

  toJSON(message: TSModelFormula): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.expr !== undefined) {
      obj.expr = message.expr;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TSModelFormula>, I>>(base?: I): TSModelFormula {
    return TSModelFormula.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TSModelFormula>, I>>(object: I): TSModelFormula {
    const message = createBaseTSModelFormula();
    message.name = object.name ?? undefined;
    message.id = object.id ?? undefined;
    message.expr = object.expr ?? undefined;
    return message;
  },
};

function createBaseWorksheetTML(): WorksheetTML {
  return { name: undefined, description: undefined, worksheet_columns: [], formulas: [], tables: [], table_paths: [] };
}

export const WorksheetTML: MessageFns<WorksheetTML> = {
  encode(message: WorksheetTML, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    for (const v of message.worksheet_columns) {
      TSModelColumn.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.formulas) {
      TSModelFormula.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.tables) {
      TSModelTable.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.table_paths) {
      WorksheetTML_TablePath.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorksheetTML {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorksheetTML();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.worksheet_columns.push(TSModelColumn.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.formulas.push(TSModelFormula.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tables.push(TSModelTable.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.table_paths.push(WorksheetTML_TablePath.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorksheetTML {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      worksheet_columns: globalThis.Array.isArray(object?.worksheet_columns)
        ? object.worksheet_columns.map((e: any) => TSModelColumn.fromJSON(e))
        : [],
      formulas: globalThis.Array.isArray(object?.formulas)
        ? object.formulas.map((e: any) => TSModelFormula.fromJSON(e))
        : [],
      tables: globalThis.Array.isArray(object?.tables) ? object.tables.map((e: any) => TSModelTable.fromJSON(e)) : [],
      table_paths: globalThis.Array.isArray(object?.table_paths)
        ? object.table_paths.map((e: any) => WorksheetTML_TablePath.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WorksheetTML): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.worksheet_columns?.length) {
      obj.worksheet_columns = message.worksheet_columns.map((e) => TSModelColumn.toJSON(e));
    }
    if (message.formulas?.length) {
      obj.formulas = message.formulas.map((e) => TSModelFormula.toJSON(e));
    }
    if (message.tables?.length) {
      obj.tables = message.tables.map((e) => TSModelTable.toJSON(e));
    }
    if (message.table_paths?.length) {
      obj.table_paths = message.table_paths.map((e) => WorksheetTML_TablePath.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorksheetTML>, I>>(base?: I): WorksheetTML {
    return WorksheetTML.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorksheetTML>, I>>(object: I): WorksheetTML {
    const message = createBaseWorksheetTML();
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.worksheet_columns = object.worksheet_columns?.map((e) => TSModelColumn.fromPartial(e)) || [];
    message.formulas = object.formulas?.map((e) => TSModelFormula.fromPartial(e)) || [];
    message.tables = object.tables?.map((e) => TSModelTable.fromPartial(e)) || [];
    message.table_paths = object.table_paths?.map((e) => WorksheetTML_TablePath.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWorksheetTML_TablePath(): WorksheetTML_TablePath {
  return { id: undefined, table: undefined };
}

export const WorksheetTML_TablePath: MessageFns<WorksheetTML_TablePath> = {
  encode(message: WorksheetTML_TablePath, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.table !== undefined) {
      writer.uint32(18).string(message.table);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorksheetTML_TablePath {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorksheetTML_TablePath();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.table = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorksheetTML_TablePath {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      table: isSet(object.table) ? globalThis.String(object.table) : undefined,
    };
  },

  toJSON(message: WorksheetTML_TablePath): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.table !== undefined) {
      obj.table = message.table;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorksheetTML_TablePath>, I>>(base?: I): WorksheetTML_TablePath {
    return WorksheetTML_TablePath.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorksheetTML_TablePath>, I>>(object: I): WorksheetTML_TablePath {
    const message = createBaseWorksheetTML_TablePath();
    message.id = object.id ?? undefined;
    message.table = object.table ?? undefined;
    return message;
  },
};

function createBaseModelTML(): ModelTML {
  return { name: undefined, description: undefined, model_tables: [], columns: [], formulas: [] };
}

export const ModelTML: MessageFns<ModelTML> = {
  encode(message: ModelTML, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    for (const v of message.model_tables) {
      TSModelTable.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.columns) {
      TSModelColumn.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.formulas) {
      TSModelFormula.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModelTML {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModelTML();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.model_tables.push(TSModelTable.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.columns.push(TSModelColumn.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.formulas.push(TSModelFormula.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModelTML {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      model_tables: globalThis.Array.isArray(object?.model_tables)
        ? object.model_tables.map((e: any) => TSModelTable.fromJSON(e))
        : [],
      columns: globalThis.Array.isArray(object?.columns)
        ? object.columns.map((e: any) => TSModelColumn.fromJSON(e))
        : [],
      formulas: globalThis.Array.isArray(object?.formulas)
        ? object.formulas.map((e: any) => TSModelFormula.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ModelTML): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.model_tables?.length) {
      obj.model_tables = message.model_tables.map((e) => TSModelTable.toJSON(e));
    }
    if (message.columns?.length) {
      obj.columns = message.columns.map((e) => TSModelColumn.toJSON(e));
    }
    if (message.formulas?.length) {
      obj.formulas = message.formulas.map((e) => TSModelFormula.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModelTML>, I>>(base?: I): ModelTML {
    return ModelTML.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModelTML>, I>>(object: I): ModelTML {
    const message = createBaseModelTML();
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.model_tables = object.model_tables?.map((e) => TSModelTable.fromPartial(e)) || [];
    message.columns = object.columns?.map((e) => TSModelColumn.fromPartial(e)) || [];
    message.formulas = object.formulas?.map((e) => TSModelFormula.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTableTML(): TableTML {
  return {
    name: undefined,
    description: undefined,
    db: undefined,
    schema: undefined,
    db_table: undefined,
    connection: undefined,
    columns: [],
  };
}

export const TableTML: MessageFns<TableTML> = {
  encode(message: TableTML, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    if (message.db !== undefined) {
      writer.uint32(26).string(message.db);
    }
    if (message.schema !== undefined) {
      writer.uint32(34).string(message.schema);
    }
    if (message.db_table !== undefined) {
      writer.uint32(42).string(message.db_table);
    }
    if (message.connection !== undefined) {
      Connection.encode(message.connection, writer.uint32(50).fork()).join();
    }
    for (const v of message.columns) {
      TableTML_TableColumn.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TableTML {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTableTML();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.db = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.schema = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.db_table = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.connection = Connection.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.columns.push(TableTML_TableColumn.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TableTML {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      db: isSet(object.db) ? globalThis.String(object.db) : undefined,
      schema: isSet(object.schema) ? globalThis.String(object.schema) : undefined,
      db_table: isSet(object.db_table) ? globalThis.String(object.db_table) : undefined,
      connection: isSet(object.connection) ? Connection.fromJSON(object.connection) : undefined,
      columns: globalThis.Array.isArray(object?.columns)
        ? object.columns.map((e: any) => TableTML_TableColumn.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TableTML): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.db !== undefined) {
      obj.db = message.db;
    }
    if (message.schema !== undefined) {
      obj.schema = message.schema;
    }
    if (message.db_table !== undefined) {
      obj.db_table = message.db_table;
    }
    if (message.connection !== undefined) {
      obj.connection = Connection.toJSON(message.connection);
    }
    if (message.columns?.length) {
      obj.columns = message.columns.map((e) => TableTML_TableColumn.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TableTML>, I>>(base?: I): TableTML {
    return TableTML.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TableTML>, I>>(object: I): TableTML {
    const message = createBaseTableTML();
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.db = object.db ?? undefined;
    message.schema = object.schema ?? undefined;
    message.db_table = object.db_table ?? undefined;
    message.connection = (object.connection !== undefined && object.connection !== null)
      ? Connection.fromPartial(object.connection)
      : undefined;
    message.columns = object.columns?.map((e) => TableTML_TableColumn.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTableTML_TableColumn(): TableTML_TableColumn {
  return {
    name: undefined,
    db_column_name: undefined,
    properties: undefined,
    db_column_properties: undefined,
    data_type: undefined,
  };
}

export const TableTML_TableColumn: MessageFns<TableTML_TableColumn> = {
  encode(message: TableTML_TableColumn, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.db_column_name !== undefined) {
      writer.uint32(18).string(message.db_column_name);
    }
    if (message.properties !== undefined) {
      ColumnProperties.encode(message.properties, writer.uint32(26).fork()).join();
    }
    if (message.db_column_properties !== undefined) {
      TableTML_TableColumn_DatabaseColumnProperties.encode(message.db_column_properties, writer.uint32(34).fork())
        .join();
    }
    if (message.data_type !== undefined) {
      writer.uint32(42).string(message.data_type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TableTML_TableColumn {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTableTML_TableColumn();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.db_column_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.properties = ColumnProperties.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.db_column_properties = TableTML_TableColumn_DatabaseColumnProperties.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.data_type = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TableTML_TableColumn {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      db_column_name: isSet(object.db_column_name) ? globalThis.String(object.db_column_name) : undefined,
      properties: isSet(object.properties) ? ColumnProperties.fromJSON(object.properties) : undefined,
      db_column_properties: isSet(object.db_column_properties)
        ? TableTML_TableColumn_DatabaseColumnProperties.fromJSON(object.db_column_properties)
        : undefined,
      data_type: isSet(object.data_type) ? globalThis.String(object.data_type) : undefined,
    };
  },

  toJSON(message: TableTML_TableColumn): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.db_column_name !== undefined) {
      obj.db_column_name = message.db_column_name;
    }
    if (message.properties !== undefined) {
      obj.properties = ColumnProperties.toJSON(message.properties);
    }
    if (message.db_column_properties !== undefined) {
      obj.db_column_properties = TableTML_TableColumn_DatabaseColumnProperties.toJSON(message.db_column_properties);
    }
    if (message.data_type !== undefined) {
      obj.data_type = message.data_type;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TableTML_TableColumn>, I>>(base?: I): TableTML_TableColumn {
    return TableTML_TableColumn.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TableTML_TableColumn>, I>>(object: I): TableTML_TableColumn {
    const message = createBaseTableTML_TableColumn();
    message.name = object.name ?? undefined;
    message.db_column_name = object.db_column_name ?? undefined;
    message.properties = (object.properties !== undefined && object.properties !== null)
      ? ColumnProperties.fromPartial(object.properties)
      : undefined;
    message.db_column_properties = (object.db_column_properties !== undefined && object.db_column_properties !== null)
      ? TableTML_TableColumn_DatabaseColumnProperties.fromPartial(object.db_column_properties)
      : undefined;
    message.data_type = object.data_type ?? undefined;
    return message;
  },
};

function createBaseTableTML_TableColumn_DatabaseColumnProperties(): TableTML_TableColumn_DatabaseColumnProperties {
  return { data_type: undefined };
}

export const TableTML_TableColumn_DatabaseColumnProperties: MessageFns<TableTML_TableColumn_DatabaseColumnProperties> =
  {
    encode(
      message: TableTML_TableColumn_DatabaseColumnProperties,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.data_type !== undefined) {
        writer.uint32(10).string(message.data_type);
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): TableTML_TableColumn_DatabaseColumnProperties {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      let end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseTableTML_TableColumn_DatabaseColumnProperties();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.data_type = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): TableTML_TableColumn_DatabaseColumnProperties {
      return { data_type: isSet(object.data_type) ? globalThis.String(object.data_type) : undefined };
    },

    toJSON(message: TableTML_TableColumn_DatabaseColumnProperties): unknown {
      const obj: any = {};
      if (message.data_type !== undefined) {
        obj.data_type = message.data_type;
      }
      return obj;
    },

    create<I extends Exact<DeepPartial<TableTML_TableColumn_DatabaseColumnProperties>, I>>(
      base?: I,
    ): TableTML_TableColumn_DatabaseColumnProperties {
      return TableTML_TableColumn_DatabaseColumnProperties.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<TableTML_TableColumn_DatabaseColumnProperties>, I>>(
      object: I,
    ): TableTML_TableColumn_DatabaseColumnProperties {
      const message = createBaseTableTML_TableColumn_DatabaseColumnProperties();
      message.data_type = object.data_type ?? undefined;
      return message;
    },
  };

function createBaseConnection(): Connection {
  return { name: undefined, id: undefined, fqn: undefined };
}

export const Connection: MessageFns<Connection> = {
  encode(message: Connection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.id !== undefined) {
      writer.uint32(18).string(message.id);
    }
    if (message.fqn !== undefined) {
      writer.uint32(26).string(message.fqn);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Connection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fqn = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Connection {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      fqn: isSet(object.fqn) ? globalThis.String(object.fqn) : undefined,
    };
  },

  toJSON(message: Connection): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.fqn !== undefined) {
      obj.fqn = message.fqn;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Connection>, I>>(base?: I): Connection {
    return Connection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Connection>, I>>(object: I): Connection {
    const message = createBaseConnection();
    message.name = object.name ?? undefined;
    message.id = object.id ?? undefined;
    message.fqn = object.fqn ?? undefined;
    return message;
  },
};

function createBaseColumnProperties(): ColumnProperties {
  return { column_type: undefined, aggregation: undefined, synonyms: [] };
}

export const ColumnProperties: MessageFns<ColumnProperties> = {
  encode(message: ColumnProperties, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.column_type !== undefined) {
      writer.uint32(10).string(message.column_type);
    }
    if (message.aggregation !== undefined) {
      writer.uint32(18).string(message.aggregation);
    }
    for (const v of message.synonyms) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ColumnProperties {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColumnProperties();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column_type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.aggregation = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.synonyms.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ColumnProperties {
    return {
      column_type: isSet(object.column_type) ? globalThis.String(object.column_type) : undefined,
      aggregation: isSet(object.aggregation) ? globalThis.String(object.aggregation) : undefined,
      synonyms: globalThis.Array.isArray(object?.synonyms) ? object.synonyms.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ColumnProperties): unknown {
    const obj: any = {};
    if (message.column_type !== undefined) {
      obj.column_type = message.column_type;
    }
    if (message.aggregation !== undefined) {
      obj.aggregation = message.aggregation;
    }
    if (message.synonyms?.length) {
      obj.synonyms = message.synonyms;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ColumnProperties>, I>>(base?: I): ColumnProperties {
    return ColumnProperties.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ColumnProperties>, I>>(object: I): ColumnProperties {
    const message = createBaseColumnProperties();
    message.column_type = object.column_type ?? undefined;
    message.aggregation = object.aggregation ?? undefined;
    message.synonyms = object.synonyms?.map((e) => e) || [];
    return message;
  },
};

function createBaseSQLViewTML(): SQLViewTML {
  return { name: undefined, description: undefined, connection: undefined, sql_query: undefined, sql_view_columns: [] };
}

export const SQLViewTML: MessageFns<SQLViewTML> = {
  encode(message: SQLViewTML, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    if (message.connection !== undefined) {
      Connection.encode(message.connection, writer.uint32(26).fork()).join();
    }
    if (message.sql_query !== undefined) {
      writer.uint32(34).string(message.sql_query);
    }
    for (const v of message.sql_view_columns) {
      TSModelColumn.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SQLViewTML {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSQLViewTML();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.connection = Connection.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sql_query = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sql_view_columns.push(TSModelColumn.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SQLViewTML {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      connection: isSet(object.connection) ? Connection.fromJSON(object.connection) : undefined,
      sql_query: isSet(object.sql_query) ? globalThis.String(object.sql_query) : undefined,
      sql_view_columns: globalThis.Array.isArray(object?.sql_view_columns)
        ? object.sql_view_columns.map((e: any) => TSModelColumn.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SQLViewTML): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.connection !== undefined) {
      obj.connection = Connection.toJSON(message.connection);
    }
    if (message.sql_query !== undefined) {
      obj.sql_query = message.sql_query;
    }
    if (message.sql_view_columns?.length) {
      obj.sql_view_columns = message.sql_view_columns.map((e) => TSModelColumn.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SQLViewTML>, I>>(base?: I): SQLViewTML {
    return SQLViewTML.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SQLViewTML>, I>>(object: I): SQLViewTML {
    const message = createBaseSQLViewTML();
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.connection = (object.connection !== undefined && object.connection !== null)
      ? Connection.fromPartial(object.connection)
      : undefined;
    message.sql_query = object.sql_query ?? undefined;
    message.sql_view_columns = object.sql_view_columns?.map((e) => TSModelColumn.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateUpdateConnectionRequest(): CreateUpdateConnectionRequest {
  return {
    name: undefined,
    description: undefined,
    data_warehouse_type: undefined,
    data_warehouse_config: undefined,
    validate: undefined,
  };
}

export const CreateUpdateConnectionRequest: MessageFns<CreateUpdateConnectionRequest> = {
  encode(message: CreateUpdateConnectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    if (message.data_warehouse_type !== undefined) {
      writer.uint32(24).int32(message.data_warehouse_type);
    }
    if (message.data_warehouse_config !== undefined) {
      writer.uint32(42).string(message.data_warehouse_config);
    }
    if (message.validate !== undefined) {
      writer.uint32(32).bool(message.validate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateUpdateConnectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateUpdateConnectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.data_warehouse_type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.data_warehouse_config = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.validate = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateUpdateConnectionRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      data_warehouse_type: isSet(object.data_warehouse_type)
        ? dataWarehouseTypeFromJSON(object.data_warehouse_type)
        : undefined,
      data_warehouse_config: isSet(object.data_warehouse_config)
        ? globalThis.String(object.data_warehouse_config)
        : undefined,
      validate: isSet(object.validate) ? globalThis.Boolean(object.validate) : undefined,
    };
  },

  toJSON(message: CreateUpdateConnectionRequest): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.data_warehouse_type !== undefined) {
      obj.data_warehouse_type = dataWarehouseTypeToJSON(message.data_warehouse_type);
    }
    if (message.data_warehouse_config !== undefined) {
      obj.data_warehouse_config = message.data_warehouse_config;
    }
    if (message.validate !== undefined) {
      obj.validate = message.validate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateUpdateConnectionRequest>, I>>(base?: I): CreateUpdateConnectionRequest {
    return CreateUpdateConnectionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateUpdateConnectionRequest>, I>>(
    object: I,
  ): CreateUpdateConnectionRequest {
    const message = createBaseCreateUpdateConnectionRequest();
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.data_warehouse_type = object.data_warehouse_type ?? undefined;
    message.data_warehouse_config = object.data_warehouse_config ?? undefined;
    message.validate = object.validate ?? undefined;
    return message;
  },
};

function createBaseCreateConnectionResponse(): CreateConnectionResponse {
  return { id: undefined, name: undefined, data_warehouse_type: undefined };
}

export const CreateConnectionResponse: MessageFns<CreateConnectionResponse> = {
  encode(message: CreateConnectionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.data_warehouse_type !== undefined) {
      writer.uint32(24).int32(message.data_warehouse_type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateConnectionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateConnectionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.data_warehouse_type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateConnectionResponse {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      data_warehouse_type: isSet(object.data_warehouse_type)
        ? dataWarehouseTypeFromJSON(object.data_warehouse_type)
        : undefined,
    };
  },

  toJSON(message: CreateConnectionResponse): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.data_warehouse_type !== undefined) {
      obj.data_warehouse_type = dataWarehouseTypeToJSON(message.data_warehouse_type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateConnectionResponse>, I>>(base?: I): CreateConnectionResponse {
    return CreateConnectionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateConnectionResponse>, I>>(object: I): CreateConnectionResponse {
    const message = createBaseCreateConnectionResponse();
    message.id = object.id ?? undefined;
    message.name = object.name ?? undefined;
    message.data_warehouse_type = object.data_warehouse_type ?? undefined;
    return message;
  },
};

function createBaseDataWarehouseObjectInput(): DataWarehouseObjectInput {
  return { database: undefined, schema: undefined, table: undefined, column: undefined };
}

export const DataWarehouseObjectInput: MessageFns<DataWarehouseObjectInput> = {
  encode(message: DataWarehouseObjectInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.database !== undefined) {
      writer.uint32(10).string(message.database);
    }
    if (message.schema !== undefined) {
      writer.uint32(18).string(message.schema);
    }
    if (message.table !== undefined) {
      writer.uint32(26).string(message.table);
    }
    if (message.column !== undefined) {
      writer.uint32(34).string(message.column);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataWarehouseObjectInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataWarehouseObjectInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.database = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.schema = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.table = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.column = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataWarehouseObjectInput {
    return {
      database: isSet(object.database) ? globalThis.String(object.database) : undefined,
      schema: isSet(object.schema) ? globalThis.String(object.schema) : undefined,
      table: isSet(object.table) ? globalThis.String(object.table) : undefined,
      column: isSet(object.column) ? globalThis.String(object.column) : undefined,
    };
  },

  toJSON(message: DataWarehouseObjectInput): unknown {
    const obj: any = {};
    if (message.database !== undefined) {
      obj.database = message.database;
    }
    if (message.schema !== undefined) {
      obj.schema = message.schema;
    }
    if (message.table !== undefined) {
      obj.table = message.table;
    }
    if (message.column !== undefined) {
      obj.column = message.column;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataWarehouseObjectInput>, I>>(base?: I): DataWarehouseObjectInput {
    return DataWarehouseObjectInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataWarehouseObjectInput>, I>>(object: I): DataWarehouseObjectInput {
    const message = createBaseDataWarehouseObjectInput();
    message.database = object.database ?? undefined;
    message.schema = object.schema ?? undefined;
    message.table = object.table ?? undefined;
    message.column = object.column ?? undefined;
    return message;
  },
};

function createBaseConnectionInput(): ConnectionInput {
  return { identifier: undefined, name_pattern: undefined, data_warehouse_objects: [] };
}

export const ConnectionInput: MessageFns<ConnectionInput> = {
  encode(message: ConnectionInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.identifier !== undefined) {
      writer.uint32(10).string(message.identifier);
    }
    if (message.name_pattern !== undefined) {
      writer.uint32(18).string(message.name_pattern);
    }
    for (const v of message.data_warehouse_objects) {
      DataWarehouseObjectInput.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConnectionInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnectionInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.identifier = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name_pattern = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.data_warehouse_objects.push(DataWarehouseObjectInput.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConnectionInput {
    return {
      identifier: isSet(object.identifier) ? globalThis.String(object.identifier) : undefined,
      name_pattern: isSet(object.name_pattern) ? globalThis.String(object.name_pattern) : undefined,
      data_warehouse_objects: globalThis.Array.isArray(object?.data_warehouse_objects)
        ? object.data_warehouse_objects.map((e: any) => DataWarehouseObjectInput.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ConnectionInput): unknown {
    const obj: any = {};
    if (message.identifier !== undefined) {
      obj.identifier = message.identifier;
    }
    if (message.name_pattern !== undefined) {
      obj.name_pattern = message.name_pattern;
    }
    if (message.data_warehouse_objects?.length) {
      obj.data_warehouse_objects = message.data_warehouse_objects.map((e) => DataWarehouseObjectInput.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConnectionInput>, I>>(base?: I): ConnectionInput {
    return ConnectionInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConnectionInput>, I>>(object: I): ConnectionInput {
    const message = createBaseConnectionInput();
    message.identifier = object.identifier ?? undefined;
    message.name_pattern = object.name_pattern ?? undefined;
    message.data_warehouse_objects =
      object.data_warehouse_objects?.map((e) => DataWarehouseObjectInput.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSearchConnectionRequest(): SearchConnectionRequest {
  return {
    connections: [],
    record_offset: undefined,
    record_size: undefined,
    data_warehouse_object_type: undefined,
    include_details: undefined,
  };
}

export const SearchConnectionRequest: MessageFns<SearchConnectionRequest> = {
  encode(message: SearchConnectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.connections) {
      ConnectionInput.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.record_offset !== undefined) {
      writer.uint32(16).int32(message.record_offset);
    }
    if (message.record_size !== undefined) {
      writer.uint32(24).int32(message.record_size);
    }
    if (message.data_warehouse_object_type !== undefined) {
      writer.uint32(32).int32(message.data_warehouse_object_type);
    }
    if (message.include_details !== undefined) {
      writer.uint32(40).bool(message.include_details);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchConnectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchConnectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.connections.push(ConnectionInput.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.record_offset = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.record_size = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.data_warehouse_object_type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.include_details = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchConnectionRequest {
    return {
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => ConnectionInput.fromJSON(e))
        : [],
      record_offset: isSet(object.record_offset) ? globalThis.Number(object.record_offset) : undefined,
      record_size: isSet(object.record_size) ? globalThis.Number(object.record_size) : undefined,
      data_warehouse_object_type: isSet(object.data_warehouse_object_type)
        ? dataWarehouseObjectTypeFromJSON(object.data_warehouse_object_type)
        : undefined,
      include_details: isSet(object.include_details) ? globalThis.Boolean(object.include_details) : undefined,
    };
  },

  toJSON(message: SearchConnectionRequest): unknown {
    const obj: any = {};
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => ConnectionInput.toJSON(e));
    }
    if (message.record_offset !== undefined) {
      obj.record_offset = Math.round(message.record_offset);
    }
    if (message.record_size !== undefined) {
      obj.record_size = Math.round(message.record_size);
    }
    if (message.data_warehouse_object_type !== undefined) {
      obj.data_warehouse_object_type = dataWarehouseObjectTypeToJSON(message.data_warehouse_object_type);
    }
    if (message.include_details !== undefined) {
      obj.include_details = message.include_details;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchConnectionRequest>, I>>(base?: I): SearchConnectionRequest {
    return SearchConnectionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchConnectionRequest>, I>>(object: I): SearchConnectionRequest {
    const message = createBaseSearchConnectionRequest();
    message.connections = object.connections?.map((e) => ConnectionInput.fromPartial(e)) || [];
    message.record_offset = object.record_offset ?? undefined;
    message.record_size = object.record_size ?? undefined;
    message.data_warehouse_object_type = object.data_warehouse_object_type ?? undefined;
    message.include_details = object.include_details ?? undefined;
    return message;
  },
};

function createBaseColumn(): Column {
  return {
    name: undefined,
    data_type: undefined,
    is_aggregate: undefined,
    can_import: undefined,
    selected: undefined,
    is_linked_active: undefined,
  };
}

export const Column: MessageFns<Column> = {
  encode(message: Column, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.data_type !== undefined) {
      writer.uint32(18).string(message.data_type);
    }
    if (message.is_aggregate !== undefined) {
      writer.uint32(26).string(message.is_aggregate);
    }
    if (message.can_import !== undefined) {
      writer.uint32(32).bool(message.can_import);
    }
    if (message.selected !== undefined) {
      writer.uint32(40).bool(message.selected);
    }
    if (message.is_linked_active !== undefined) {
      writer.uint32(48).bool(message.is_linked_active);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Column {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColumn();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data_type = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.is_aggregate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.can_import = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.selected = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.is_linked_active = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Column {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      data_type: isSet(object.data_type) ? globalThis.String(object.data_type) : undefined,
      is_aggregate: isSet(object.is_aggregate) ? globalThis.String(object.is_aggregate) : undefined,
      can_import: isSet(object.can_import) ? globalThis.Boolean(object.can_import) : undefined,
      selected: isSet(object.selected) ? globalThis.Boolean(object.selected) : undefined,
      is_linked_active: isSet(object.is_linked_active) ? globalThis.Boolean(object.is_linked_active) : undefined,
    };
  },

  toJSON(message: Column): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.data_type !== undefined) {
      obj.data_type = message.data_type;
    }
    if (message.is_aggregate !== undefined) {
      obj.is_aggregate = message.is_aggregate;
    }
    if (message.can_import !== undefined) {
      obj.can_import = message.can_import;
    }
    if (message.selected !== undefined) {
      obj.selected = message.selected;
    }
    if (message.is_linked_active !== undefined) {
      obj.is_linked_active = message.is_linked_active;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Column>, I>>(base?: I): Column {
    return Column.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Column>, I>>(object: I): Column {
    const message = createBaseColumn();
    message.name = object.name ?? undefined;
    message.data_type = object.data_type ?? undefined;
    message.is_aggregate = object.is_aggregate ?? undefined;
    message.can_import = object.can_import ?? undefined;
    message.selected = object.selected ?? undefined;
    message.is_linked_active = object.is_linked_active ?? undefined;
    return message;
  },
};

function createBaseTable(): Table {
  return {
    name: undefined,
    columns: [],
    type: undefined,
    description: undefined,
    selected: undefined,
    linked: undefined,
    relationships: [],
  };
}

export const Table: MessageFns<Table> = {
  encode(message: Table, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    for (const v of message.columns) {
      Column.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.type !== undefined) {
      writer.uint32(26).string(message.type);
    }
    if (message.description !== undefined) {
      writer.uint32(34).string(message.description);
    }
    if (message.selected !== undefined) {
      writer.uint32(40).bool(message.selected);
    }
    if (message.linked !== undefined) {
      writer.uint32(48).bool(message.linked);
    }
    for (const v of message.relationships) {
      writer.uint32(58).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Table {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.columns.push(Column.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.selected = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.linked = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.relationships.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Table {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      columns: globalThis.Array.isArray(object?.columns) ? object.columns.map((e: any) => Column.fromJSON(e)) : [],
      type: isSet(object.type) ? globalThis.String(object.type) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      selected: isSet(object.selected) ? globalThis.Boolean(object.selected) : undefined,
      linked: isSet(object.linked) ? globalThis.Boolean(object.linked) : undefined,
      relationships: globalThis.Array.isArray(object?.relationships)
        ? object.relationships.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: Table): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.columns?.length) {
      obj.columns = message.columns.map((e) => Column.toJSON(e));
    }
    if (message.type !== undefined) {
      obj.type = message.type;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.selected !== undefined) {
      obj.selected = message.selected;
    }
    if (message.linked !== undefined) {
      obj.linked = message.linked;
    }
    if (message.relationships?.length) {
      obj.relationships = message.relationships;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Table>, I>>(base?: I): Table {
    return Table.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Table>, I>>(object: I): Table {
    const message = createBaseTable();
    message.name = object.name ?? undefined;
    message.columns = object.columns?.map((e) => Column.fromPartial(e)) || [];
    message.type = object.type ?? undefined;
    message.description = object.description ?? undefined;
    message.selected = object.selected ?? undefined;
    message.linked = object.linked ?? undefined;
    message.relationships = object.relationships?.map((e) => e) || [];
    return message;
  },
};

function createBaseSchema(): Schema {
  return { name: undefined, tables: [] };
}

export const Schema: MessageFns<Schema> = {
  encode(message: Schema, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    for (const v of message.tables) {
      Table.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Schema {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSchema();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tables.push(Table.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Schema {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      tables: globalThis.Array.isArray(object?.tables) ? object.tables.map((e: any) => Table.fromJSON(e)) : [],
    };
  },

  toJSON(message: Schema): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.tables?.length) {
      obj.tables = message.tables.map((e) => Table.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Schema>, I>>(base?: I): Schema {
    return Schema.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Schema>, I>>(object: I): Schema {
    const message = createBaseSchema();
    message.name = object.name ?? undefined;
    message.tables = object.tables?.map((e) => Table.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDatabase(): Database {
  return { name: undefined, schemas: [], auto_created: undefined };
}

export const Database: MessageFns<Database> = {
  encode(message: Database, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    for (const v of message.schemas) {
      Schema.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.auto_created !== undefined) {
      writer.uint32(24).bool(message.auto_created);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Database {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatabase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.schemas.push(Schema.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.auto_created = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Database {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      schemas: globalThis.Array.isArray(object?.schemas) ? object.schemas.map((e: any) => Schema.fromJSON(e)) : [],
      auto_created: isSet(object.auto_created) ? globalThis.Boolean(object.auto_created) : undefined,
    };
  },

  toJSON(message: Database): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.schemas?.length) {
      obj.schemas = message.schemas.map((e) => Schema.toJSON(e));
    }
    if (message.auto_created !== undefined) {
      obj.auto_created = message.auto_created;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Database>, I>>(base?: I): Database {
    return Database.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Database>, I>>(object: I): Database {
    const message = createBaseDatabase();
    message.name = object.name ?? undefined;
    message.schemas = object.schemas?.map((e) => Schema.fromPartial(e)) || [];
    message.auto_created = object.auto_created ?? undefined;
    return message;
  },
};

function createBaseDataWarehouseObject(): DataWarehouseObject {
  return { databases: [] };
}

export const DataWarehouseObject: MessageFns<DataWarehouseObject> = {
  encode(message: DataWarehouseObject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.databases) {
      Database.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataWarehouseObject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataWarehouseObject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.databases.push(Database.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataWarehouseObject {
    return {
      databases: globalThis.Array.isArray(object?.databases)
        ? object.databases.map((e: any) => Database.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DataWarehouseObject): unknown {
    const obj: any = {};
    if (message.databases?.length) {
      obj.databases = message.databases.map((e) => Database.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataWarehouseObject>, I>>(base?: I): DataWarehouseObject {
    return DataWarehouseObject.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataWarehouseObject>, I>>(object: I): DataWarehouseObject {
    const message = createBaseDataWarehouseObject();
    message.databases = object.databases?.map((e) => Database.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSearchConnectionResponse(): SearchConnectionResponse {
  return {
    id: undefined,
    name: undefined,
    description: undefined,
    data_warehouse_type: undefined,
    data_warehouse_objects: undefined,
  };
}

export const SearchConnectionResponse: MessageFns<SearchConnectionResponse> = {
  encode(message: SearchConnectionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.data_warehouse_type !== undefined) {
      writer.uint32(32).int32(message.data_warehouse_type);
    }
    if (message.data_warehouse_objects !== undefined) {
      DataWarehouseObject.encode(message.data_warehouse_objects, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchConnectionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchConnectionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.data_warehouse_type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.data_warehouse_objects = DataWarehouseObject.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchConnectionResponse {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      data_warehouse_type: isSet(object.data_warehouse_type)
        ? dataWarehouseTypeFromJSON(object.data_warehouse_type)
        : undefined,
      data_warehouse_objects: isSet(object.data_warehouse_objects)
        ? DataWarehouseObject.fromJSON(object.data_warehouse_objects)
        : undefined,
    };
  },

  toJSON(message: SearchConnectionResponse): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.data_warehouse_type !== undefined) {
      obj.data_warehouse_type = dataWarehouseTypeToJSON(message.data_warehouse_type);
    }
    if (message.data_warehouse_objects !== undefined) {
      obj.data_warehouse_objects = DataWarehouseObject.toJSON(message.data_warehouse_objects);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchConnectionResponse>, I>>(base?: I): SearchConnectionResponse {
    return SearchConnectionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchConnectionResponse>, I>>(object: I): SearchConnectionResponse {
    const message = createBaseSearchConnectionResponse();
    message.id = object.id ?? undefined;
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.data_warehouse_type = object.data_warehouse_type ?? undefined;
    message.data_warehouse_objects =
      (object.data_warehouse_objects !== undefined && object.data_warehouse_objects !== null)
        ? DataWarehouseObject.fromPartial(object.data_warehouse_objects)
        : undefined;
    return message;
  },
};

function createBaseTMLImportRequest(): TMLImportRequest {
  return { metadata_tmls: [], import_policy: undefined, create_new: undefined };
}

export const TMLImportRequest: MessageFns<TMLImportRequest> = {
  encode(message: TMLImportRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.metadata_tmls) {
      writer.uint32(10).string(v!);
    }
    if (message.import_policy !== undefined) {
      writer.uint32(16).int32(message.import_policy);
    }
    if (message.create_new !== undefined) {
      writer.uint32(24).bool(message.create_new);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TMLImportRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTMLImportRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata_tmls.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.import_policy = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.create_new = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TMLImportRequest {
    return {
      metadata_tmls: globalThis.Array.isArray(object?.metadata_tmls)
        ? object.metadata_tmls.map((e: any) => globalThis.String(e))
        : [],
      import_policy: isSet(object.import_policy) ? importPolicyFromJSON(object.import_policy) : undefined,
      create_new: isSet(object.create_new) ? globalThis.Boolean(object.create_new) : undefined,
    };
  },

  toJSON(message: TMLImportRequest): unknown {
    const obj: any = {};
    if (message.metadata_tmls?.length) {
      obj.metadata_tmls = message.metadata_tmls;
    }
    if (message.import_policy !== undefined) {
      obj.import_policy = importPolicyToJSON(message.import_policy);
    }
    if (message.create_new !== undefined) {
      obj.create_new = message.create_new;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TMLImportRequest>, I>>(base?: I): TMLImportRequest {
    return TMLImportRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TMLImportRequest>, I>>(object: I): TMLImportRequest {
    const message = createBaseTMLImportRequest();
    message.metadata_tmls = object.metadata_tmls?.map((e) => e) || [];
    message.import_policy = object.import_policy ?? undefined;
    message.create_new = object.create_new ?? undefined;
    return message;
  },
};

function createBaseTMLImportResponse(): TMLImportResponse {
  return { response: undefined, request_index: undefined };
}

export const TMLImportResponse: MessageFns<TMLImportResponse> = {
  encode(message: TMLImportResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.response !== undefined) {
      TMLImportResponse_TMLResponseEntity.encode(message.response, writer.uint32(10).fork()).join();
    }
    if (message.request_index !== undefined) {
      writer.uint32(16).int32(message.request_index);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TMLImportResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTMLImportResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.response = TMLImportResponse_TMLResponseEntity.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.request_index = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TMLImportResponse {
    return {
      response: isSet(object.response) ? TMLImportResponse_TMLResponseEntity.fromJSON(object.response) : undefined,
      request_index: isSet(object.request_index) ? globalThis.Number(object.request_index) : undefined,
    };
  },

  toJSON(message: TMLImportResponse): unknown {
    const obj: any = {};
    if (message.response !== undefined) {
      obj.response = TMLImportResponse_TMLResponseEntity.toJSON(message.response);
    }
    if (message.request_index !== undefined) {
      obj.request_index = Math.round(message.request_index);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TMLImportResponse>, I>>(base?: I): TMLImportResponse {
    return TMLImportResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TMLImportResponse>, I>>(object: I): TMLImportResponse {
    const message = createBaseTMLImportResponse();
    message.response = (object.response !== undefined && object.response !== null)
      ? TMLImportResponse_TMLResponseEntity.fromPartial(object.response)
      : undefined;
    message.request_index = object.request_index ?? undefined;
    return message;
  },
};

function createBaseTMLImportResponse_TMLImportResponseHeader(): TMLImportResponse_TMLImportResponseHeader {
  return {
    author_name: undefined,
    author_guid: undefined,
    id_guid: undefined,
    metadata_type: undefined,
    name: undefined,
    type: undefined,
  };
}

export const TMLImportResponse_TMLImportResponseHeader: MessageFns<TMLImportResponse_TMLImportResponseHeader> = {
  encode(message: TMLImportResponse_TMLImportResponseHeader, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.author_name !== undefined) {
      writer.uint32(10).string(message.author_name);
    }
    if (message.author_guid !== undefined) {
      writer.uint32(18).string(message.author_guid);
    }
    if (message.id_guid !== undefined) {
      writer.uint32(26).string(message.id_guid);
    }
    if (message.metadata_type !== undefined) {
      writer.uint32(34).string(message.metadata_type);
    }
    if (message.name !== undefined) {
      writer.uint32(42).string(message.name);
    }
    if (message.type !== undefined) {
      writer.uint32(50).string(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TMLImportResponse_TMLImportResponseHeader {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTMLImportResponse_TMLImportResponseHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.author_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.author_guid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id_guid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.metadata_type = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.type = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TMLImportResponse_TMLImportResponseHeader {
    return {
      author_name: isSet(object.author_name) ? globalThis.String(object.author_name) : undefined,
      author_guid: isSet(object.author_guid) ? globalThis.String(object.author_guid) : undefined,
      id_guid: isSet(object.id_guid) ? globalThis.String(object.id_guid) : undefined,
      metadata_type: isSet(object.metadata_type) ? globalThis.String(object.metadata_type) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      type: isSet(object.type) ? globalThis.String(object.type) : undefined,
    };
  },

  toJSON(message: TMLImportResponse_TMLImportResponseHeader): unknown {
    const obj: any = {};
    if (message.author_name !== undefined) {
      obj.author_name = message.author_name;
    }
    if (message.author_guid !== undefined) {
      obj.author_guid = message.author_guid;
    }
    if (message.id_guid !== undefined) {
      obj.id_guid = message.id_guid;
    }
    if (message.metadata_type !== undefined) {
      obj.metadata_type = message.metadata_type;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.type !== undefined) {
      obj.type = message.type;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TMLImportResponse_TMLImportResponseHeader>, I>>(
    base?: I,
  ): TMLImportResponse_TMLImportResponseHeader {
    return TMLImportResponse_TMLImportResponseHeader.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TMLImportResponse_TMLImportResponseHeader>, I>>(
    object: I,
  ): TMLImportResponse_TMLImportResponseHeader {
    const message = createBaseTMLImportResponse_TMLImportResponseHeader();
    message.author_name = object.author_name ?? undefined;
    message.author_guid = object.author_guid ?? undefined;
    message.id_guid = object.id_guid ?? undefined;
    message.metadata_type = object.metadata_type ?? undefined;
    message.name = object.name ?? undefined;
    message.type = object.type ?? undefined;
    return message;
  },
};

function createBaseTMLImportResponse_Status(): TMLImportResponse_Status {
  return { status_code: undefined, error_message: undefined };
}

export const TMLImportResponse_Status: MessageFns<TMLImportResponse_Status> = {
  encode(message: TMLImportResponse_Status, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status_code !== undefined) {
      writer.uint32(10).string(message.status_code);
    }
    if (message.error_message !== undefined) {
      writer.uint32(18).string(message.error_message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TMLImportResponse_Status {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTMLImportResponse_Status();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status_code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error_message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TMLImportResponse_Status {
    return {
      status_code: isSet(object.status_code) ? globalThis.String(object.status_code) : undefined,
      error_message: isSet(object.error_message) ? globalThis.String(object.error_message) : undefined,
    };
  },

  toJSON(message: TMLImportResponse_Status): unknown {
    const obj: any = {};
    if (message.status_code !== undefined) {
      obj.status_code = message.status_code;
    }
    if (message.error_message !== undefined) {
      obj.error_message = message.error_message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TMLImportResponse_Status>, I>>(base?: I): TMLImportResponse_Status {
    return TMLImportResponse_Status.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TMLImportResponse_Status>, I>>(object: I): TMLImportResponse_Status {
    const message = createBaseTMLImportResponse_Status();
    message.status_code = object.status_code ?? undefined;
    message.error_message = object.error_message ?? undefined;
    return message;
  },
};

function createBaseTMLImportResponse_TMLResponseEntity(): TMLImportResponse_TMLResponseEntity {
  return { header: undefined, status: undefined };
}

export const TMLImportResponse_TMLResponseEntity: MessageFns<TMLImportResponse_TMLResponseEntity> = {
  encode(message: TMLImportResponse_TMLResponseEntity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      TMLImportResponse_TMLImportResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.status !== undefined) {
      TMLImportResponse_Status.encode(message.status, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TMLImportResponse_TMLResponseEntity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTMLImportResponse_TMLResponseEntity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = TMLImportResponse_TMLImportResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.status = TMLImportResponse_Status.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TMLImportResponse_TMLResponseEntity {
    return {
      header: isSet(object.header) ? TMLImportResponse_TMLImportResponseHeader.fromJSON(object.header) : undefined,
      status: isSet(object.status) ? TMLImportResponse_Status.fromJSON(object.status) : undefined,
    };
  },

  toJSON(message: TMLImportResponse_TMLResponseEntity): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = TMLImportResponse_TMLImportResponseHeader.toJSON(message.header);
    }
    if (message.status !== undefined) {
      obj.status = TMLImportResponse_Status.toJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TMLImportResponse_TMLResponseEntity>, I>>(
    base?: I,
  ): TMLImportResponse_TMLResponseEntity {
    return TMLImportResponse_TMLResponseEntity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TMLImportResponse_TMLResponseEntity>, I>>(
    object: I,
  ): TMLImportResponse_TMLResponseEntity {
    const message = createBaseTMLImportResponse_TMLResponseEntity();
    message.header = (object.header !== undefined && object.header !== null)
      ? TMLImportResponse_TMLImportResponseHeader.fromPartial(object.header)
      : undefined;
    message.status = (object.status !== undefined && object.status !== null)
      ? TMLImportResponse_Status.fromPartial(object.status)
      : undefined;
    return message;
  },
};

function createBaseCreateDataModelResponse(): CreateDataModelResponse {
  return { model_id: undefined, model_name: undefined, error_message: undefined };
}

export const CreateDataModelResponse: MessageFns<CreateDataModelResponse> = {
  encode(message: CreateDataModelResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.model_id !== undefined) {
      writer.uint32(10).string(message.model_id);
    }
    if (message.model_name !== undefined) {
      writer.uint32(18).string(message.model_name);
    }
    if (message.error_message !== undefined) {
      writer.uint32(26).string(message.error_message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateDataModelResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateDataModelResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.model_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.model_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.error_message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateDataModelResponse {
    return {
      model_id: isSet(object.model_id) ? globalThis.String(object.model_id) : undefined,
      model_name: isSet(object.model_name) ? globalThis.String(object.model_name) : undefined,
      error_message: isSet(object.error_message) ? globalThis.String(object.error_message) : undefined,
    };
  },

  toJSON(message: CreateDataModelResponse): unknown {
    const obj: any = {};
    if (message.model_id !== undefined) {
      obj.model_id = message.model_id;
    }
    if (message.model_name !== undefined) {
      obj.model_name = message.model_name;
    }
    if (message.error_message !== undefined) {
      obj.error_message = message.error_message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateDataModelResponse>, I>>(base?: I): CreateDataModelResponse {
    return CreateDataModelResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateDataModelResponse>, I>>(object: I): CreateDataModelResponse {
    const message = createBaseCreateDataModelResponse();
    message.model_id = object.model_id ?? undefined;
    message.model_name = object.model_name ?? undefined;
    message.error_message = object.error_message ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
